import React from "react";
import PolicyLayout from "./PolicyLayout";

export default function Terms() {
  return (
    <PolicyLayout title="Terms & Conditions" eyebrow="Legal · Terms" effectiveDate="Effective Date: March 1, 2023">
      <p>
        Welcome to the official platforms of <strong>React Disaster Management Solutions OPC Pvt. Ltd.</strong>
        {" "}(“Company”, “we”, “our”, or “us”). These Terms &amp; Conditions (“Terms”) govern your access to and use of our
        websites, mobile applications, and services (collectively, the “Platforms”). By accessing or using our Platforms,
        you agree to be bound by these Terms. If you do not agree, you must discontinue use immediately.
      </p>

      <h2>1. Scope of Platforms</h2>
      <p>These Terms apply to all websites, applications, and services operated by us, including but not limited to:</p>
      <p><strong>Websites</strong></p>
      <ul>
        <li><a href="https://reactdm.com" target="_blank" rel="noreferrer">reactdm.com</a></li>
        <li><a href="https://reactdms.tech" target="_blank" rel="noreferrer">reactdms.tech</a></li>
        <li><a href="https://wastemanagement.tech" target="_blank" rel="noreferrer">wastemanagement.tech</a></li>
        <li><a href="https://rescigo.com" target="_blank" rel="noreferrer">rescigo.com</a></li>
        <li><a href="https://rescigohealth.com" target="_blank" rel="noreferrer">rescigohealth.com</a></li>
        <li><a href="https://rescigo.in" target="_blank" rel="noreferrer">rescigo.in</a></li>
        <li><a href="https://saferhome.in" target="_blank" rel="noreferrer">saferhome.in</a></li>
        <li><a href="https://bmwtrack.tech" target="_blank" rel="noreferrer">bmwtrack.tech</a></li>
      </ul>
      <p><strong>Mobile Applications</strong></p>
      <ul>
        <li>REACT</li>
        <li>REACT Alerts</li>
        <li>Rescigo Health</li>
        <li>SaferHome</li>
        <li>BMWTrack</li>
      </ul>

      <h2>2. Eligibility</h2>
      <p>You must be at least 18 years old to use our Platforms. If you are under 18, you may use the Platforms only with the consent of a parent or guardian.</p>

      <h2>3. User Responsibilities</h2>
      <p>
        You agree to use the Platforms only for lawful purposes. You are responsible for the accuracy of the information you provide.
        Unauthorized use, including but not limited to hacking, scraping, or reverse engineering, is strictly prohibited.
      </p>

      <h2>4. Intellectual Property</h2>
      <p>
        All content, trademarks, logos, and intellectual property on the Platforms are owned by React Disaster Management Solutions OPC Pvt. Ltd.
        or its licensors. You may not copy, reproduce, or use them without prior written consent.
      </p>

      <h2>5. Services and Charges</h2>
      <p>
        Our citizen services are free of charge. Certain services for service providers are chargeable. Fees, if applicable, will be
        communicated on the relevant service page. We reserve the right to modify, suspend, or discontinue services at any time.
      </p>

      <h2>6. Limitation of Liability</h2>
      <p>
        We make no warranties or guarantees regarding uninterrupted or error-free access to our Platforms. To the maximum extent permitted by law,
        we shall not be liable for any damages, losses, or expenses arising from the use or inability to use our Platforms.
      </p>

      <h2>7. Refund Policy</h2>
      <p>
        Fees once paid are non-refundable for successfully availed services. Failed or unsuccessful transactions will be automatically
        refunded as per RBI/Government guidelines. Department-specific refund/cancellation policies may apply.
        See the full <a href="/refund">Cancellation &amp; Refund Policy</a>.
      </p>

      <h2>8. Termination</h2>
      <p>We reserve the right to suspend or terminate user accounts without notice for violations of these Terms.</p>

      <h2>9. Governing Law</h2>
      <p>
        These Terms are governed by and construed under the laws of India. Any disputes shall fall under the exclusive jurisdiction of
        the courts in Trivandrum, Kerala.
      </p>

      <h2>10. Contact Information</h2>
      <p>For queries, complaints, or grievances, please contact:</p>
      <p>
        📧 <a href="mailto:care@rescigo.in">care@rescigo.in</a><br />
        📞 <a href="tel:+917306087704">7306087704</a>
      </p>

      <hr className="my-10 border-slate-200" />
      <p className="text-sm text-slate-500">
        React Disaster Management Solutions OPC Pvt. Ltd. reserves the right to update or modify these Terms at any time without prior notice.
        Continued use of our Platforms after such updates constitutes acceptance of the revised Terms.
      </p>
    </PolicyLayout>
  );
}
